<template>
  <div>
    <router-link
      v-if="!isExternal"
      class="flex items-center pt-[20px] pb-[16px] pl-[26px] text-[16px] leading-[20px] rounded-xl button-font font-semibold h-[56px]"
      style="box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1)"
      :class="
        isActive
          ? textColour + hoverColor
          : 'bg-white text-[#808080] drop-shadow-tile ' + hoverColor
      "
      :to="to"
      :data-test-id="dataTestId"
      @mouseover="hover = true"
      @mouseleave="hover = false"
      @click="$emit('clicked-button')"
    >
      <span
        v-if="typeof icon === 'string'"
        class="outline-icon-mask"
        :style="{ '--icon-url': `url(${icon})` }"
        role="img"
        :aria-label="label"
      ></span>
      <component v-else :is="icon" :is-active="isActive || hover" />
      <span class="ml-[20px]">{{ label }}</span>
    </router-link>
    <a
      v-else
      class="flex items-center pt-[20px] pb-[16px] pl-[26px] text-[16px] leading-[20px] rounded-lg button-font font-semibold hover:underline h-[56px] bg-white text-grey-100 drop-shadow-tile"
      :href="to"
      :data-test-id="dataTestId"
      target="_blank"
    >
      <span
        v-if="typeof icon === 'string'"
        class="outline-icon-mask"
        :style="{ '--icon-url': `url(${icon})` }"
        role="img"
        :aria-label="label"
      ></span>
      <component v-else :is="icon" />
      <span class="ml-[20px]">{{ label }}</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    isExternal: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: null,
      required: true,
    },
    label: {
      type: String,
      default: null,
      required: true,
    },
    icon: {
      type: [Object, String],
      default: null,
      required: true,
    },
    dataEventTracking: {
      type: String,
      default: null,
    },
    dataTestId: {
      type: String,
      default: null,
    },
    isGic: {
      type: Boolean,
      default: false,
    },
    activePath: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    isActive() {
      const activePath = this.activePath || this.to;
      const isIncludes = this.$route.path.includes(activePath) && activePath !== '/';
      return this.$route.path === activePath || isIncludes;
    },
    textColour() {
      return this.isGic ? 'text-orange bg-orange-10 ' : 'text-lightblue bg-grey-10 ';
    },
    hoverColor() {
      return this.isGic ? 'hover:text-orange' : 'hover:text-lightblue';
    },
  },
};
</script>

<style scoped>
.button-font {
  font-size: 16px;
}

.outline-icon-mask {
  background-color: currentColor;
  display: inline-block;
  flex: 0 0 32px;
  height: 32px;
  width: 32px;
  -webkit-mask-image: var(--icon-url);
  mask-image: var(--icon-url);
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
}
</style>
